export var SiteUserRoles;
(function (SiteUserRoles) {
    SiteUserRoles["SITE_AUDITOR"] = "roles/mom.siteAuditor";
    SiteUserRoles["SITE_CLINICAL_RESEARCH_ASSOCIATE"] = "roles/mom.siteClinicalResearchAssociate";
    SiteUserRoles["SITE_PRINCIPAL_INVESTIGATOR"] = "roles/mom.sitePrincipalInvestigator";
    SiteUserRoles["SITE_RESEARCH_COORDINATOR"] = "roles/mom.siteResearchCoordinator";
    SiteUserRoles["SITE_REVIEWER"] = "roles/mom.siteReviewer";
})(SiteUserRoles || (SiteUserRoles = {}));
